module.exports = __webpack_public_path__ + "media/images/hyperstacks-8357a04ccba4024075e73fafbe58f538.png";